import { create } from 'zustand';
import type { NarrativeState, DecisionLogEntry } from '@/types';
import { cargar, guardar } from '@/engine/persistence';

interface NarrativeStoreState extends NarrativeState {
  cargado: boolean;
  irAEscena: (sceneId: string) => void;
  registrarDecision: (entry: DecisionLogEntry) => void;
  resolverConsecuencia: (consequenceId: string, impacto: string) => void;
  setCapitulo: (capitulo: number) => void;
  marcarFinal: (finalId: string) => void;
  reiniciar: () => void;
  cargarDesdeStorage: () => void;
  persistir: () => void;
}

const ESTADO_INICIAL: NarrativeState = {
  sceneIdActual: null,
  capituloActual: 1,
  historialEscenas: [],
  decisiones: [],
  finalAlcanzado: null,
};

export const useNarrativeStore = create<NarrativeStoreState>((set, get) => ({
  ...ESTADO_INICIAL,
  cargado: false,

  irAEscena: (sceneId) => {
    set((s) => ({
      sceneIdActual: sceneId,
      historialEscenas: [...s.historialEscenas, sceneId],
    }));
    get().persistir();
  },

  registrarDecision: (entry) => {
    set((s) => ({ decisiones: [...s.decisiones, entry] }));
    get().persistir();
  },

  resolverConsecuencia: (consequenceId, impacto) => {
    set((s) => ({
      decisiones: s.decisiones.map((d) =>
        d.consequencePendiente === consequenceId
          ? { ...d, impactoDiferidoResuelto: impacto }
          : d,
      ),
    }));
    get().persistir();
  },

  setCapitulo: (capitulo) => {
    set({ capituloActual: capitulo });
    get().persistir();
  },

  marcarFinal: (finalId) => {
    set({ finalAlcanzado: finalId });
    get().persistir();
  },

  reiniciar: () => {
    set({ ...ESTADO_INICIAL, cargado: true });
    get().persistir();
  },

  cargarDesdeStorage: () => {
    const r = cargar<NarrativeState>('narrative');
    if (r.status === 'ok') {
      set({ ...r.valor, cargado: true });
    } else {
      set({ cargado: true });
    }
  },

  persistir: () => {
    const s = get();
    guardar('narrative', {
      sceneIdActual: s.sceneIdActual,
      capituloActual: s.capituloActual,
      historialEscenas: s.historialEscenas,
      decisiones: s.decisiones,
      finalAlcanzado: s.finalAlcanzado,
    });
  },
}));
